import { render } from "./NurseryHoursDiaryContainer.vue?vue&type=template&id=2cbc772a&ts=true"
import script from "./NurseryHoursDiaryContainer.vue?vue&type=script&lang=ts"
export * from "./NurseryHoursDiaryContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__